var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1EDFD",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C34CD",
    fillRule: "evenodd",
    d: "M8 10.25a.75.75 0 0 0-.53 1.28l4 4a.75.75 0 0 0 1.06 0l4-4a.75.75 0 0 0-.53-1.28H8",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;